class ImageVideoSlideshowSection {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-slideshow-track]');
    this.slides = Array.from(root.querySelectorAll('[data-slideshow-slide]'));
    this.prevButton = root.querySelector('[data-slideshow-prev]');
    this.nextButton = root.querySelector('[data-slideshow-next]');
    if (!this.track || this.slides.length === 0) return;

    this.index = 0;
    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    this.autoplayTimer = null;

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.go(this.index - 1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.go(this.index + 1));

    if (this.prevButton && this.nextButton) {
      root.addEventListener('mousemove', (event) => this.handleMouseMove(event));
      root.addEventListener('mouseleave', () => this.hideArrows());
    }

    if (this.autoplay && this.slides.length > 1) {
      this.startAutoplay();
      root.addEventListener('mouseenter', () => this.stopAutoplay());
      root.addEventListener('mouseleave', () => this.startAutoplay());
    }

    window.addEventListener('resize', () => this.update(false));

    this.root.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', () => this.updateHeight());
    });

    this.update(false);
  }

  handleMouseMove(event) {
    const bounds = this.root.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    const isLeftHalf = x < bounds.width / 2;

    const activeArrow = isLeftHalf ? this.prevButton : this.nextButton;
    const inactiveArrow = isLeftHalf ? this.nextButton : this.prevButton;

    activeArrow.style.top = `${y}px`;
    activeArrow.style.left = `${x}px`;
    activeArrow.classList.add('is-visible');
    inactiveArrow.classList.remove('is-visible');
  }

  hideArrows() {
    if (this.prevButton) this.prevButton.classList.remove('is-visible');
    if (this.nextButton) this.nextButton.classList.remove('is-visible');
  }

  go(newIndex) {
    const total = this.slides.length;
    this.index = (newIndex + total) % total;
    this.update(true);
  }

  update(animate) {
    this.track.style.transition = animate ? '' : 'none';
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    this.updateHeight();
  }

  updateHeight() {
    const currentSlide = this.slides[this.index];
    if (!currentSlide) return;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const mobileRatio = parseFloat(currentSlide.dataset.aspectRatioMobile);
    const ratio = isMobile && mobileRatio ? mobileRatio : parseFloat(currentSlide.dataset.aspectRatio);

    if (ratio && ratio > 0) {
      this.root.style.height = `${this.root.clientWidth / ratio}px`;
      return;
    }

    const media = currentSlide.querySelector('img, video');
    if (media) {
      const naturalW = media.naturalWidth || media.videoWidth;
      const naturalH = media.naturalHeight || media.videoHeight;
      if (naturalW && naturalH) {
        this.root.style.height = `${this.root.clientWidth * (naturalH / naturalW)}px`;
      }
    }
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }
}

document.querySelectorAll('[data-slideshow]').forEach((root) => {
  new ImageVideoSlideshowSection(root);
});
